import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Center, Loader, Stack, Text } from '@mantine/core';
import { useAuth } from '../lib/auth/useAuth';

export function RequireAuth() {
  const { session, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <Center mih="100vh">
        <Stack align="center" gap="sm" className="app-fade-in">
          <Loader color="brand" />
          <Text c="dimmed">Lade Session…</Text>
        </Stack>
      </Center>
    );
  }

  const locked = typeof window !== 'undefined' && localStorage.getItem('mk-admin-locked') === 'true';
  if (!session || locked) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  return <Outlet />;
}
